import {
  ENQUEUE_SNACKBAR,
  CLOSE_SNACKBAR,
  REMOVE_SNACKBAR,
} from "actions/ActionTypes";

export const notifSuccess = (message, details) =>
  sendNotif(message, details, "success");

export const notifError = (message, details) =>
  sendNotif(message, details, "error");

export const notifInfo = (message, details) =>
  sendNotif(message, details, "info");

export const notifWarning = (message, details) =>
  sendNotif(message, details, "warning");

const sendNotif = (message, details, severity) => ({
  type: ENQUEUE_SNACKBAR,
  notification: {
    message,
    options: {
      details,
      variant: severity,
    },
    key: new Date().getTime() + Math.random(),
  },
});

export const closeSnackbar = (key) => ({
  type: CLOSE_SNACKBAR,
  dismissAll: !key, // dismiss all if no key has been defined
  key,
});

export const removeSnackbar = (key) => ({
  type: REMOVE_SNACKBAR,
  key,
});
